import styled from 'styled-components';
import { color } from '../../../../Assets/color';

export const CheckInRow = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    margin: 5px 0;
`;

export const RowName = styled.div`
    flex: 1;
`;

export const CreditInput = styled.input`
    width: 52px;
    height: 30px;
    border-radius: 3px;
    border: none;
    background-color: rgba(239, 240, 242, 0.18);
    text-align: center;
    font-size: 14px;
    color: #909fac;
    outline: none;
    margin-left: 20px;

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const CheckedInButton = styled.button`
    width: 100px;
    height: 23px;
    border-radius: 100px;
    background-color: #fff;
    border: none;
    font-size: 12px;
    text-transform: uppercase;
    cursor: pointer;
    color: ${color('red')};
    outline: none;
`;

export const CheckInButton = styled.button`
    width: 100px;
    height: 23px;
    border-radius: 100px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    cursor: pointer;
    outline: none;
`;

export const DisabledCheckInButton = styled(CheckInButton)`
    opacity: 0.5;
    cursor: default;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/CheckInRow/style.js